// libs
import isEmpty from 'lodash/isEmpty';

// types
import { IFaqItem } from './types';

export const shouldShowListingFaq = ({
  faq,
  showListingFooter,
  isDynamicPageURL,
  isAeoFaqEnabled = false,
}: {
  faq?: IFaqItem[] | null;
  showListingFooter: boolean;
  isDynamicPageURL: boolean;
  isAeoFaqEnabled?: boolean;
}): boolean =>
  Boolean(isAeoFaqEnabled && showListingFooter && !isDynamicPageURL && !isEmpty(faq));
